import React from "react";
import "./App.css";
import ControllableStates from "./ControllableStates";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src="/icon.png" className="App-logo"></img>
        <h1 className="pageTitle"> Six Degrees Of Survivor</h1>
        <p>
          {" "}
          Enter the names of any two Survivor players. We'll find a link between
          them for you!{" "}
        </p>
        <ControllableStates />
      </header>
    </div>
  );
}

export default App;
